import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  getCatalogCollapseStatus,
  selectKP11SelectCartCentersNApps,
  updateCatalogCollapseStatus,
} from '../../../../../../app-store/kp11CartSlice'
import {
  CardPlanBodyStyle,
  CardPlanWebsiteUrlStyle,
  IsBillingDateRadioStyle,
  CardPlanHeaderStyle,
} from '../kp-11Link-catalog-cards-style'
import {PlanRadioInput} from '../../../kp-11Link-reusable-components/kp-plan-radio-input'
import {CardPlanItemWrapStyle} from '../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {FloatingInput} from '../../../kp-11Link-reusable-components/kp-reusable-input'
// import {StartDateSelector} from '../../../kp-11Link-reusable-components/kp-date-selector'
import {
  buildCartEntity,
  getItemFromCart,
} from '../../../kp-11Link-utility/kp11-utility'
// import dayjs from 'dayjs'
import {useAuthClient} from '../../../../../../utils/use-auth-client'
import {useAsync} from '../../../../../../utils/use-async'
import {kP11LinkService} from '../../../kp-11Link-utility/kp11-service'
import {fetchPlanIcon} from '../../../../../../utils/fetch-plan-icon'
import {Button, Icon} from '@thryvlabs/maverick'
import {ProductNamePriceComponent} from '../../../../kp-card-type/product-name-price-component'

// plan website url
export const ThryvLeadsProposalIdComponent = ({
  leadsData,
  setLeadsData,
  required = true,
  isAlreadyAdded = false,
}) => {
  const client = useAuthClient()
  const {run} = useAsync({status: 'pending'})

  const validateProposalId = async proposalId => {
    if (isAlreadyAdded) {
      return
    }
    setLeadsData({loading: true, isError: false, helperText: ''})

    try {
      const response = await kP11LinkService.validateThryvLeadsProposalId(
        run,
        client,
        proposalId,
      )
      // let response = {}
      // if (proposalId === '1') {
      //   response = {
      //     leadId: 'Q5J2DLV',
      //     passed: true,
      //     budget: 400,
      //   }
      // } else {
      //   response = {
      //     leadId: 'Q5J2DLV',
      //     passed: false,
      //     reason: 'Invalid proposal Id',
      //   }
      // }

      const {budget, reason} = response || {}
      if (response?.passed) {
        setLeadsData({
          thryvLeadAmount: budget ?? '',
          isLeadsIdValidated: true,
          isError: false,
          helperText: '',
          loading: false,
        })
      } else {
        setLeadsData({
          thryvLeadAmount: '',
          isLeadsIdValidated: false,
          isError: true,
          helperText: reason,
          loading: false,
        })
      }
    } catch (err) {
      //const errorCode = err?.code?.toUpperCase?.() || ''
      setLeadsData({
        isError: true,
        helperText:
          'This campaign ID is currently Live, Paused, or Cancelled and cannot be reused.',
        isLeadsIdValidated: false,
        loading: false,
      })
    }
  }

  // Debounce validation
  useEffect(() => {
    if (!leadsData.thryvLeadsId) {
      setLeadsData({
        isError: false,
        helperText: '',
        isLeadsIdValidated: false,
      })
      return
    }
    const handler = setTimeout(
      () => validateProposalId(leadsData.thryvLeadsId),
      1000,
    )
    return () => clearTimeout(handler)
  }, [leadsData.thryvLeadsId])

  const handleBlur = () => {
    if (required && !leadsData.thryvLeadsId) {
      setLeadsData({
        isError: true,
        helperText: 'Proposal ID is required',
        isLeadsIdValidated: false,
      })
    }
  }

  return (
    <FloatingInput
      label="Enter Proposal ID"
      type="text"
      value={leadsData?.thryvLeadsId}
      onChange={e => setLeadsData({thryvLeadsId: e.target.value})}
      onBlur={handleBlur}
      isValid={leadsData?.isLeadsIdValidated || isAlreadyAdded}
      isError={leadsData?.isError}
      helperText={leadsData?.helperText}
      loading={leadsData?.loading}
      required={required}
      isDisabled={isAlreadyAdded}
    />
  )
}

/* ----------------------- External Domain Radio ----------------------- */
export const BillingDateOptRadio = ({leadsData, setLeadsData, disabled}) => {
  const handleChange = e => {
    const radioValue = e.target.value
    if (radioValue === 'no') {
      setLeadsData({
        isDiffBillingDate: e.target.value,
        futureBillingDate: '',
        // futureBillingDate: dayjs(new Date()).format('YYYY-MM-DD'),
      })
    } else if (radioValue === 'yes') {
      setLeadsData({isDiffBillingDate: e.target.value})
    }
  }

  return (
    <IsBillingDateRadioStyle>
      {['yes', 'no'].map(value => (
        <label
          key={value}
          className={`bd-radio-label-wrap ${disabled ? 'disabled' : ''}`}
        >
          <input
            className={`bd-radio-input ${disabled ? 'disabled' : ''}`}
            type="radio"
            name="isExternalDomain"
            value={value}
            checked={leadsData?.isDiffBillingDate === value}
            onChange={handleChange}
            disabled={disabled}
          />
          <span className="bd-radio-label">
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </span>
        </label>
      ))}
    </IsBillingDateRadioStyle>
  )
}

// Catalog card component
export const KP11LinkThryvLeadsCardComponent = ({
  selectedCountry = 'US',
  groupKey,
  items,
  onSelectItem,
  groupCustomFields,
  onGroupCustomFieldsUpdate,
  disabled,
  addedToCart,
  isChildComponent = false,
}) => {
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const cardCollapseStatus = useSelector(getCatalogCollapseStatus)
  const dispatch = useDispatch()
  const selectedItem = getItemFromCart({
    cartCentersAndApps,
    groupKey,
    items,
  })

  const [leadsData, setLeadsData] = useState({
    thryvLeadsId: groupCustomFields?.thryvLeadsId ?? '',
    isLeadsIdValidated: groupCustomFields?.isLeadsIdValidated ?? false,
    futureBillingDate: groupCustomFields?.futureBillingDate ?? '',
    thryvLeadAmount: groupCustomFields?.thryvLeadAmount ?? '',
    isDiffBillingDate: groupCustomFields?.isDiffBillingDate ?? '',
    isError: groupCustomFields?.isError ?? false,
    helperText: groupCustomFields?.helperText ?? '',
    loading: groupCustomFields?.loading ?? false,
  })

  const setPartialLeadsData = partial =>
    setLeadsData(prev => ({...prev, ...partial}))

  useEffect(() => {
    onGroupCustomFieldsUpdate(leadsData)
  }, [
    leadsData.thryvLeadsId,
    leadsData.isLeadsIdValidated,
    leadsData.futureBillingDate,
    // leadsData.thryvLeadAmount,
    leadsData.isDiffBillingDate,
  ])

  const isPlanDisabled = (disabled, selectedItem, item, leadsData) => {
    const isItemAllreadyAdded = item?.isAlreadyAdded
    const isdisabled =
      disabled || isItemAllreadyAdded || !leadsData?.isLeadsIdValidated
    // !leadsData?.isLeadsIdValidated ||
    // !(
    //   leadsData?.isDiffBillingDate === 'no' ||
    //   (leadsData?.isDiffBillingDate === 'yes' && leadsData?.futureBillingDate)
    // )
    return isdisabled
  }

  const isAddToCartDisabled = !leadsData?.isLeadsIdValidated

  return (
    <>
      <div
        className={`d-flex flex-column w-100${
          disabled ? ' disable-with-opacity' : ''
        }`}
      >
        <CardPlanHeaderStyle
          onClick={() => {
            // !disabled && onExpand()
            dispatch(updateCatalogCollapseStatus('thryv leads'))
          }}
        >
          <div className="card-heading justify-content-between w-100">
            <div className="d-flex flex-row align-items-center gap-4">
              <div className="card-icon">
                <img
                  src={fetchPlanIcon(items[0].name).icon}
                  alt="plan logo"
                  className="options-logo rounded"
                />
              </div>
              <div className="card-title-text">{items[0].name}</div>
            </div>
            <div>
              <Icon
                type={'solid'}
                variant={
                  cardCollapseStatus['thryv leads'] ? 'caretDown' : `caretRight`
                }
                height={'15'}
                width={'15'}
                color={'#FF6100'}
              />
            </div>
          </div>
        </CardPlanHeaderStyle>
        {cardCollapseStatus['thryv leads'] && (
          <CardPlanBodyStyle>
            <CardPlanWebsiteUrlStyle>
              <ThryvLeadsProposalIdComponent
                leadsData={leadsData}
                setLeadsData={setPartialLeadsData}
                required={true}
                isAlreadyAdded={selectedItem?.isAlreadyAdded}
              />
            </CardPlanWebsiteUrlStyle>
            {/* {leadsData?.isLeadsIdValidated && (
          <CardPlanBillingDateWrapperStyle>
            <div className="tl-billing-label">
              Do you want to start the billing on a different date?
            </div>
            <div className="tl-billing-option">
              <BillingDateOptRadio
                leadsData={leadsData}
                setLeadsData={setPartialLeadsData}
                disabled={!leadsData.isLeadsIdValidated}
              />
            </div>
            {leadsData?.isDiffBillingDate === 'yes' && (
              <StartDateSelector
                leadsData={leadsData}
                setLeadsData={setPartialLeadsData}
                disabled={!leadsData.isLeadsIdValidated}
              ></StartDateSelector>
            )}
          </CardPlanBillingDateWrapperStyle>
        )} */}

            {/* <div className="card-plan-subText">Select a subscription plan</div> */}

            <CardPlanItemWrapStyle>
              {items.length > 1 ? (
                items.map(item => (
                  <PlanRadioInput
                    key={item.code}
                    checked={selectedItem?.code === item.code}
                    disabled={isPlanDisabled(
                      disabled,
                      selectedItem,
                      item,
                      leadsData,
                    )}
                    onChange={() => {}}
                    item={item}
                    customFields={leadsData}
                  />
                ))
              ) : (
                <ProductNamePriceComponent
                  cardDetail={items[0]}
                  isIconRequired={false}
                  // isNameRequired={false}
                  customFields={leadsData}
                  country={selectedCountry}
                  disabled={isPlanDisabled(
                    disabled,
                    selectedItem,
                    items[0],
                    leadsData,
                  )}
                />
              )}
            </CardPlanItemWrapStyle>
            <div className="d-flex w-100 justify-content-center">
              <Button
                variant="primary"
                disabled={isAddToCartDisabled}
                onClick={() => {
                  const updatedItem = buildCartEntity({
                    kind: 'item',
                    source: items[0],
                    selectedCountry,
                    quantity: Number(leadsData?.thryvLeadAmount) || 1,
                    customFields: leadsData,
                  })
                  onSelectItem(updatedItem)
                }}
              >
                Add to Cart
              </Button>
            </div>
          </CardPlanBodyStyle>
        )}
      </div>
    </>
  )
}
